export interface CustomFieldEntityTypeOption {
  value: string;
  label: string;
}

/** Stable entity type keys used in custom field definitions and values API. */
export const CUSTOM_FIELD_ENTITY = {
  CLIENT: 'Client',
  CLIENT_CONTACT: 'ClientContact',
  TODO: 'Todo',
  APPOINTMENT: 'Appointment',
  EMAIL: 'Email',
  EMAIL_TEMPLATE: 'EmailTemplate',
  EMAIL_TEMPLATE_DOCUMENT: 'EmailTemplateDocument',
} as const;

export type CustomFieldEntityType =
  (typeof CUSTOM_FIELD_ENTITY)[keyof typeof CUSTOM_FIELD_ENTITY];

/** Entity types supported by the trimmed comm app (custom fields on forms/details). */
export const CUSTOM_FIELD_ENTITY_TYPE_OPTIONS: CustomFieldEntityTypeOption[] = [
  { value: CUSTOM_FIELD_ENTITY.CLIENT, label: 'Organization' },
  { value: CUSTOM_FIELD_ENTITY.CLIENT_CONTACT, label: 'Person' },
  { value: CUSTOM_FIELD_ENTITY.TODO, label: 'Todo' },
  { value: CUSTOM_FIELD_ENTITY.APPOINTMENT, label: 'Appointment' },
  { value: CUSTOM_FIELD_ENTITY.EMAIL, label: 'Email' },
  { value: CUSTOM_FIELD_ENTITY.EMAIL_TEMPLATE, label: 'Library template' },
  { value: CUSTOM_FIELD_ENTITY.EMAIL_TEMPLATE_DOCUMENT, label: 'Library document' },
];

export const CUSTOM_FIELD_ENTITY_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  CUSTOM_FIELD_ENTITY_TYPE_OPTIONS.map((option) => [option.value, option.label]),
);

export function getCustomFieldEntityTypeLabel(entityType: string): string {
  return CUSTOM_FIELD_ENTITY_TYPE_LABELS[entityType] ?? entityType;
}
